import { render, staticRenderFns } from "./InventoryLayout.vue?vue&type=template&id=9378dfaa"
import script from "./InventoryLayout.vue?vue&type=script&lang=js"
export * from "./InventoryLayout.vue?vue&type=script&lang=js"
import style0 from "./InventoryLayout.vue?vue&type=style&index=0&id=9378dfaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports